import React from 'react'
import { Redirect } from 'react-router'
import { DcScreen } from '../components/dc/DcScreen'
import { HeroScree } from '../components/heroes/HeroScree'
import { marvelScreen } from '../components/marvel/marvelScreen'
import { Search } from '../components/search/Search'
import { Navbar } from '../components/ui/Navbar'

import {
    Switch,
    Route,
} from "react-router-dom";

export const DashboardRoutes = () => {
    return (
        <>
            <Navbar />

            <div className='container mt-5'>

                <Switch>
                    <Route exact path='/marvel' component={marvelScreen} />
                    <Route exact path='/hero/:heroeid' component={HeroScree} />
                    <Route exact path='/dc' component={DcScreen} />
                    <Route path='/search' component={Search} />

                    <Redirect to='/marvel' />

                </Switch>

            </div>

        </>
    )
}

//:heroid =>> es un parametro de url

//puedes usar el redirec para aser condiciones si no llega la url